import { render, staticRenderFns } from "./GateManager1.vue?vue&type=template&id=15a169cc&scoped=true"
import script from "./GateManager1.vue?vue&type=script&lang=js"
export * from "./GateManager1.vue?vue&type=script&lang=js"
import style0 from "./GateManager1.vue?vue&type=style&index=0&id=15a169cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a169cc",
  null
  
)

export default component.exports